/***********************************************
	IceMedX - Developed By IceMedx Corporation
	Copyright 2011 IceMedx Corporation
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../../core/IceEntity';

export class homeoxygen extends IceEntity {
  home_oxygen_key: string = "";
  certification_type_code: string = "";
  treatment_period_count: number = 0.0;
  arterial_blood_gas_quantity: number = 0.0;
  oxygen_saturation_quantity: number = 0.0;
  oxygen_reference_identification_qualifier: string;
  oxygen_flow_rate_ref_identification: string = "";
  record_version: number = 0;
  offline_record_status: number = 0;

  constructor() {
    super();
  }

  gettablename(): string {
    return "HOME_OXYGEN";
  }
}
